import React from 'react';
import { MdOutlinePayment } from 'react-icons/md';
import { lazyPage } from '../lazyPage';

const Payment = lazyPage(() => import(/* webpackChunkName: "m-commerce" */ '../../pages/Payment'));

/** Payments view — Commerce module. Identical to the previous legacy declaration. */
const paymentsManifest = {
    id: 'payments',
    featureName: 'payment_mgmt',
    permission: 'view',
    routes: [{ path: '/payments', element: <Payment /> }],
    sidebarItems: [{ text: 'Payments', icon: <MdOutlinePayment />, link: '/payments' }],
};

export default paymentsManifest;
